import { tamarackAPI, processApiResponse } from "./Tamarack";

export const VendorDataAPI = {
	async getVendor(vendorId) {
		const path = `vendor/${vendorId}`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async getVendors(vendorName, offset) {
		const escapeLike = (s) => {
			if (s === null || s === undefined) return s;
			return String(s)
				.replace(/\\/g, "\\\\") // escape backslashes first
				.replace(/%/g, "\\%") // escape percent
				.replace(/_/g, "\\_"); // escape underscore
		};
		const escapedName = escapeLike(vendorName);
		const path = `vendors?name=${encodeURIComponent(escapedName)}&Offset=${offset}`
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async getAllVendors(offset) {
		const path = `vendors?Offset=${offset}`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async addVendor(data) {
		const path = `vendor`;
		const response = await tamarackAPI.post(path, data);
		return processApiResponse(response, "post", path);
	},
};
